/* Hoshikaki — bundle picker. Theme behaviour, not page content. */
document.addEventListener('click', function (ev) {
  var card = ev.target.closest('.hk-tier');
  if (!card) return;
  document.querySelectorAll('.hk-tier').forEach(function (x) {
    x.classList.remove('is-on');
  });
  card.classList.add('is-on');
});
